import type { ReactNode } from 'react';
import { field } from './Field.css';

export function Field({ children }: { children: ReactNode }) {
  return <div className={field}>{children}</div>;
}
